
<template>
    <div class="homeProRecShow">
        <div class="supplyList">
                <ul class="clearfix">
                    <template v-for="(item,index) in list">
                        <li :key="index">
                         <router-link :to="{ name: 'supplierdetail',params:{id:item.id} }">
                            <div class="box">
                            <div class="title">{{item.title}}</div>
                            <div class="desc">
                                {{item.zhaiyao}}
                            </div>
                            <div class="labelItem">类型:{{item.category_str}}</div>
                            <div class="labelItem">状态:{{item.demand_status_str}}</div>
                            <div class="labelItem">发布时间:{{item.add_time_str}}</div>
                            </div>
                         </router-link>
                        </li>
                    </template>
                </ul>
            </div>
            
            <div class="viewmore">
                <router-link :to="{ name: 'supply' }"><span>查看更多</span></router-link>
            </div>
    </div>
</template>

<script>
// import {Loading } from 'element-ui';
export default {
  data(){
    return{
        list:[],
        total:0,
    }
  },
  created(){
    this.GetList();
  },
  methods:{
     GetList() {
        //    this.loadingInstance = Loading.service({
        //         // 动画中的文字
        //         text:'加载中',
        //         // 要加载动画的容器
        //         target:'.app-container'
        //     });
            var url = "https://api.xincailiao.com/Open/GetPurchaseDemandList";
            this.$http.post(url,{pagesize: 5, type: 2 }).then(function(res){
                if (res.data.status==1){
                    this.list=res.data.ds;
                    this.total=res.data.total;
                    this.loadingInstance.close();
                }
            }.bind(this)).catch(function(){
            });
        },
  },
}
</script>
